export const SBP_PAYMENT_SUCCESS_TITLE = 'Отлично!';

export const SBP_PAYMENT_SUCCESS_DESCRIPTION =
	'Всё получилось. Теперь вы можете получать оплату по номеру телефона через Систему Быстрых Платежей';
